import { FormFlowPageErrorBannerProps } from '../FormFlow.decl';
import { useFormFlow } from '../useFormFlow';

import { Banner } from '@components/Banner';
import { useTranslation } from 'react-i18next';

export function FormFlowPageErrorBanner({ component }: FormFlowPageErrorBannerProps) {
  const { t } = useTranslation();
  const { errorBanner } = useFormFlow();

  return errorBanner ? (
    <Banner
      text={t(errorBanner)}
      data-test='form-flow-page-error'
      type='error'
      textVariant='subheading'
    >
      {component}
    </Banner>
  ) : null;
}
